import {
  getCookie,
  getSession,
  isDeviceUpgradeFlow,
  isECJointTransactionFlow,
  isJointTransactionFlow,
  isMoversFlow,
  isTitanOneUpgradeFlag,
  isTitanOneUpgradeFlow,
  nbxSkipTitanOneUpgradeFlag,
} from '.';

const retryFlowMapping = [
  { key: 'isPlansRetry', value: '|PLAN_RS' },
  { key: 'isPaymentFailRetry', value: '|PG_RS' },
  { key: 'isValidateOrderRetry', value: '|Validate_RS' },
  { key: 'isTransExpiryRetry', value: '|SG_RS' },
  { key: 'noAppointment', value: '|APPTMT_RS' },
  { key: 'emptyCartLQ', value: '|ECL' }, // ECL means Empty CartExist and LQResponse
  { key: 'sesExp', value: '|ESF' }, // ESF means Expired Session Flow
  { key: 'fwaProspectExpressCheckout', value: '|NSE_Express' },
  { key: 'isAppointmentRetry', value: '|APPOINTMENT_RS' },
];

const sequentialFlowMapping = [
  { type: 'MOC_FWA', value: '|SEQ_MH' }, // Sequential Flow Mobility Order confirmation page to FWA
  { type: 'MEC_FWA_NSE', value: '|SEQ_MH_MEC_NSE' }, // Sequential Flow Mobility confirmation Email to FWA with Guest Account
  { type: 'EC_MOC_FWA', value: '|SEQ_MH_EC' }, // Sequential Flow Mobility Existing Customer Order confirmation Page to FWA
  { type: 'EC_MAQ_FWA', value: '|SEQ_MH_MAQ' }, // Sequential Flow Mobility Existing Customer Order confirmation Page to FWA
];

export const getRetryFlowValues = (val) => {
  let result = val;
  retryFlowMapping.forEach(({ key, value }) => {
    if (getSession(key) === 'Y') {
      result += value;
    }
  });
   if (getSession('widgetLQHost') === 'Streamline') {
     result += '|Streamline';
    }
  return result;
};

export const getSequentialFlowValues = (val, seqFlowType) => {
  let result = val;
  sequentialFlowMapping.forEach(({ type, value }) => {
    if (seqFlowType === type) {
      result += value;
    }
  });

  if (isECJointTransactionFlow()) {
    result += '|EC_JT_MH'; // Existing Customer Joint Transaction Flow
  } else if (isJointTransactionFlow()) {
    result += '|JT_MH'; // Joint Transaction Flow
  }

  return result;
};

export const getFlowTypeValue = (FlowType, isTGWFlow, isLoggedIn) => {
  let val = '';
  const userType = isLoggedIn ? 'AAL' : 'NSE';
  if (isTGWFlow) {
    val = `${userType}_5G|TGW`;
  } else if (isDeviceUpgradeFlow() && getSession('isDUSession')) {
    val = 'FWA_DEVICE_UPGRADE'; // Device upgrade flow
  } else if (nbxSkipTitanOneUpgradeFlag()) {
    val = 'TITANONE_MIGRATION|ATE'; // Titan One Flow
  } 
  else if (isTitanOneUpgradeFlag() || isTitanOneUpgradeFlow()) {
    val = 'TITANONE_MIGRATION'; // Titan One Flow
  } else if (FlowType === 'LTE') {
    val = `${userType}_LTE|LTE`;
  } else if (FlowType === '5G') {
    const networkBandwidthType = getSession('isCBandQual') === 'Y' ? 'CBD' : 'mmWv';
    val = `${userType}_5G|${networkBandwidthType}`;
  }

  return val;
};

export const getWholeHomeWifiFlow = (value, dueTodayList, dueMonthlyList, visFeature) => {
  let result = value;
  const whwBasicCart =
    dueTodayList?.filter((obj) => obj?.itemType === 'WHWBASIC') || visFeature?.filter((obj) => obj?.categoryCodes?.[0]?.includes('WHWBASIC'));
  const whwPlusCart =
    dueMonthlyList?.filter((obj) => obj?.itemType === 'WHWPLUS') || visFeature?.filter((obj) => obj?.categoryCodes?.[0]?.includes('WHWPLUS'));

  if (whwBasicCart?.length > 0) {
    result += '|WB';
  }

  if (whwPlusCart?.length > 0) {
    result += '|WP';
  }

  const UCFlowName = getSession('UCFlowName');
  if (UCFlowName) {
    result += `|${UCFlowName}`;
  }

  const custTab = getSession('CustTab');
  if (custTab) {
    result += `|${custTab}`;
  }

  return result;
};

export const getMoversFlowValues = (val, isLoggedIn, FlowType) => {
  let result = val;

  if (isMoversFlow()) {
    const network = getSession('moversNetworkBandwidth') || getCookie('moversNetworkBandwidth');
    const value = isLoggedIn && FlowType === 'LTE' ? `AAL_LTE|${network}` : `AAL_5G|${network}`;
    result = `MOV|${network ? value : val}`;
  }

  return result;
};

export const getResumeFlow = (val) => {
  let result = val;

  const isEmailFlow = getSession('emailFlow');
  const isResumeOrder = getSession('isResumeOrder');
  const isExistingCase = getSession('ExistingCase');
  const isTestFlow = getSession('isTestFlow');

  if (isExistingCase) {
    result = `SCEXISTS|${val}`;
  }

  if (isEmailFlow) {
    result = `RETRIEVEEMAIL_5G|${val}`;
  }

  if (isResumeOrder === 'Y') {
    result = `RETRIEVEYES|${val}`;
  } else if (isResumeOrder === 'N') {
    result = `RETRIEVENO|${val}`;
  }

  if (isTestFlow && isTestFlow === 'Y') {
    result = `test|${val}`;
  }
  return result;
};

export const getOtgFlow = (val, params) => {
  let result = val;
  const isOtgFlow = !!params.has('source');

  if (isOtgFlow) {
    result = `OTG|${val}`;
  }

  return result;
};

export const getWifiBackupFlow = (isLoggedIn, wifiBackupCbandQualified) => {
  const userType = isLoggedIn ? 'AAL' : 'NSE';
  const result = wifiBackupCbandQualified ? `${userType}_5G|CBD` : `${userType}_LTE|LTE`;
  return result;
};
